import * as React from "react";
import * as S from "@styled";
import { ThemeType } from "shared/styles/theme"
import styled from "styled-components";
import theme from "styled-theming"

const tickWrapperIconColor = theme("mode", {
    [ThemeType.light]: S.Colors.purplePrimary,
    [ThemeType.dark]: S.Colors.purpleTertiary
})

const TickWrapperContainer = styled.div`
    width: 20px;
    display: inline-block;
    i {
        color: ${tickWrapperIconColor};
        font-size: var(--header-3-font-size);
    }
`

export const TickWrapper: React.FC<React.PropsWithChildren> = (props) => (
    <TickWrapperContainer>
        {props.children}
    </TickWrapperContainer>
)
